import React, { useState } from 'react';
import clsx from 'clsx';
import styles from './text-field.module.scss';

export const TextField = ({ name, label, error, required, type = 'text', value, onFocus, onBlur, ...others }) => {
  const [isFocused, setIsFocused] = useState(false);

  const inputProps = {
    id: name,
    name: name,
    onFocus: () => setIsFocused(true),
    onBlur: (e) => {
      setIsFocused(false);
      onBlur && onBlur(e);
    },
    value: value,
    ...others,
  };
  return (
    <div className={styles.inputContainer}>
      <div
        className={clsx(
          styles.inputWrapper,
          isFocused && styles.focused,
          value && styles.hasValue,
          error && styles.error
        )}
      >
        <label className={styles.label} htmlFor={name}>
          {label}
          {required && '*'}
        </label>
        {type === 'text' && (
          <>
            <label htmlFor={name}>{name}</label>
            <input className={styles.input} {...inputProps} />
          </>
        )}
        {type === 'textarea' && (
          <>
            <label htmlFor={name}>{name}</label>
            <textarea className={clsx(styles.input, styles.textarea)} {...inputProps} />
          </>
        )}
      </div>
      <span className={styles.errorMessage}>{!!error && error}</span>
    </div>
  );
};
